export class AiChatMessage {
  constructor ({
    role,
    content,
    status,
    streamId
  }) {
    this.role = role
    this.content = content
    this.status = status
    this.streamId = streamId
  }
}
